import './App.css';
import Main_routers from './Routes/Main_routers';
import ScrollToTop from './Components/Scrolltop'


function App() {
  return (
     <div>
      <ScrollToTop/>
      <Main_routers/>
    </div>
  );
}

export default App;